
import { Vue, Component, Prop } from 'vue-property-decorator';

import ModalContent from '@/components/modal/ModalContent.vue';
import ModalFullScreen from '@/components/modal/ModalFullScreenNew.vue';
import UiButton from '@/components/button/ui-button.vue';
import INSERT_PROJECT_ACTIVITY_TIME from '@/apollo/projectActivities/InsertProjectActivityTime.gql';
import { Project_Activity_Time } from '@/generated/graphql';

@Component({
	components: {
		ModalContent,
		UiButton,
		ModalFullScreen,
	},
})
export default class SubmitTimeModal extends Vue {
	@Prop({ type: String, required: true }) activityTitle!: String;
	@Prop({ type: Number, required: true }) time!: number;
	@Prop({ type: Boolean, required: true }) value!: boolean;

	closeModal(value: boolean): void {
		this.$emit('input', value);
		this.$emit('closeSubmitTimeModal');
	}
	toMinutes(time: number): number {
		// return seconds to mins with rounding to nearest minute
		return Math.round(time / 60);
	}
}
